module.exports = __webpack_public_path__ + "6107296e8e8e4f0846b0d7928923583f.jpg";